import React from 'react';


const do_nothing = () => { return };

  function ImageButton({ url, onClick, mouseEnter=do_nothing, mouseLeave=do_nothing, title='' , color='#fff066'}) {
    return (
      <button title={title} className='imagedButton'
      style={({
        alignItems: 'center',
        justifyContent: 'top',
        width: '17px',
        height: '17px',
        border: 'none',
        margin: '1px',
        padding: '2px', 
        borderRadius: '4px',
        backgroundColor: color,
        cursor: 'pointer',
        }) 
      }
      onClick={onClick} onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}
    >
      <img
        src={url}
        alt="SVG Button"
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          fill: 'white',
          backgroundColor: color ,
        }}
      />
    </button>
    );
  }
    
export default ImageButton;